import { Id } from '@/infra/id'
import type { LegendServiceType } from '@/features/jobs/legends/legend-service-type'

/**
 * The rating config.
 */
export interface JobLegendRatingConfig {
  readonly starRatingDisabled: boolean
  readonly platformRatingEnabled: boolean
  readonly proRatingEnabled: boolean
}

export const JobLegendRatingConfig = {
  default: {
    starRatingDisabled: false,
    platformRatingEnabled: false,
    proRatingEnabled: false,
  } as JobLegendRatingConfig,
}

/**
 * The TXF config.
 */
export interface JobLegendTxfConfig {
  readonly showQuestionnaire: boolean
}

export const JobLegendTxfConfig = {
  default: {
    showQuestionnaire: false,
  } as JobLegendTxfConfig,
}

/**
 * The legend job information.
 */
export interface JobLegend {
  readonly id: Id
  readonly version: number
  readonly name: string
  readonly serviceType: LegendServiceType
  readonly ratingConfig: JobLegendRatingConfig
  readonly txfConfig: JobLegendTxfConfig
  readonly isBillingEnabled: boolean
  readonly isQuoteEnabled: boolean
  readonly isRequestedProviderSelectionAllowed: boolean
}

export const JobLegend = {
  none: {
    id: Id.none,
    version: -1,
    name: 'Legend',
    ratingConfig: JobLegendRatingConfig.default,
    txfConfig: JobLegendTxfConfig.default,
    isBillingEnabled: false,
    isQuoteEnabled: false,
    isRequestedProviderSelectionAllowed: false,
  } as JobLegend,
}
